module.exports = __webpack_public_path__ + "assets/img/志愿者.d63e2cbe.png";